var React = require('react');

function HamburgerCloseInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"className":"line","d":"M40.9706 7.02944L7.02944 40.9706","stroke":"black","strokeMiterlimit":"10","key":0}),React.createElement("path",{"className":"line","d":"M40.9706 40.9706L7.02944 7.02944","stroke":"black","strokeMiterlimit":"10","key":1})]);
}

HamburgerCloseInline.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = HamburgerCloseInline;

HamburgerCloseInline.default = HamburgerCloseInline;
